import { Injectable } from '@angular/core';
import { filter, Observable, switchMap, take } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { AppState } from '@store/reducers';
import { IResponseSuccess } from '@core/interfaces';
import { selectConfiguracionCanalList, selectStore } from '@store/selectors';
import { ConfiguracionCanal, ConfiguracionCanalUpsert, Store as StoreModel } from '@core/models';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConfiguracionCanalService {
  ConfiguracionCanalList$: Observable<ConfiguracionCanal[] | null>;
  store$: Observable<StoreModel | null>;

  constructor(
    private http: HttpClient,
    private store: Store<AppState>,
  ) {
    this.ConfiguracionCanalList$ = this.store.select(selectConfiguracionCanalList);
    this.store$ = this.store.select(selectStore)
  }

  findAll(localChannelId: string): Observable<IResponseSuccess<ConfiguracionCanal>> {
    return this.store$.pipe(
      filter((store) => !!store),
      switchMap((store) => {
        return this.http.get<IResponseSuccess<ConfiguracionCanal>>(
          `${environment.microConfiguraciones}/configuracion-canal`,
          {
            params: {
              localId: store.idLocal,
              localCanalId: localChannelId,
            },
            headers: {
              authorization: store.apiKey,
            }
          },
        );
      }),
      take(1),
    );
  }

  create(payload: ConfiguracionCanalUpsert): Observable<IResponseSuccess<ConfiguracionCanal>> {
    return this.store$.pipe(
      filter((store) => !!store),
      switchMap((store) => {
        return this.http.post<IResponseSuccess<ConfiguracionCanal>>(
          `${environment.microConfiguraciones}/configuracion-canal`,
          payload,
          {
            headers: {
              authorization: store.apiKey,
            }
          }
        );
      }),
      take(1),
    );
  }
}
